// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import WhatIsTaiChiPage from "../pages/WhatIsTaiChi/WhatIsTaiChi";
const __wvcRoutePaths = ["/WhatIsTaiChiPage", "/was-ist-tai-chi"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutmepage", "coursesseminarspage", "energyflowyogapage", "homepage", "impressum", "imprintpage", "kurse-seminare", "ourstudiopage", "post", "qi-gong-yoga", "qi-gong-yoga2", "qigongandyogapage", "qigongyogapage", "startseite", "training-im-einklang", "traininginharmonypage", "uber-mich", "unser-studio", "was-ist-tai-chi", "whatistaichipage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<WhatIsTaiChiPage />} />
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<WhatIsTaiChiPage />} />
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
